import {
    Middleware,
    applyMiddleware,
    compose,
    legacy_createStore as createStore,
} from "redux";
import { createLogger } from "redux-logger";
import createRootReducer from "./reducer";
import { disableReduxLoggerFromEnv } from "../config/env.config";

const disableReduxLogger = disableReduxLoggerFromEnv();

const root = createRootReducer();

const store = createStore(
    root,
    undefined,
    compose(
        applyMiddleware(
            createLogger({ predicate: () => !disableReduxLogger }) as Middleware
        )
    )
);

export default store;
